import React from 'react';
import { MapPin } from 'lucide-react';
import { coverageAreas } from '../data';

export default function CoverageAreas() {
  return (
    <section className="bg-gray-50 py-16 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mb-4">
            Vi dækker følgende områder
          </h2>
          <p className="text-lg text-gray-600">
            VHservice tilbyder professionel vinduespudsning i en lang række områder i og omkring Storkøbenhavn. 
            Finder du ikke dit område på listen, er du altid velkommen til at kontakte os for et uforpligtende tilbud.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 max-w-5xl mx-auto">
          {coverageAreas.map((area, index) => (
            <div 
              key={index} 
              className="flex items-center space-x-2.5 bg-white p-4 border border-gray-100 shadow-xs hover:shadow-md hover:border-blue-100 transition-all duration-200"
            >
              <MapPin className="w-5 h-5 text-blue-600 shrink-0" />
              <span className="text-gray-700 font-medium text-sm sm:text-base">{area}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
